import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Lookup from '../components/Lookup';
import Visualize from '../components/Visualize';
import { geocode } from '../actions/tryActions';
import { Heading, LeadingAltSecondary } from '../../../components/Typography';
import ErrorMessage from '../../components/ErrorMessage';

const Wrapper = styled('div')`
  ${tw`container mx-auto bg-white p-6 rounded-lg`}
`

const Questions = styled('div')`
  ${tw`mx-auto max-w-3xl mt-32`}
`

class TryApp extends Component {

  static propTypes = {
		isGeocoding: PropTypes.bool,
		errorMessage: PropTypes.string,
		geocodingResult: PropTypes.object,
		query: PropTypes.string,
		direction: PropTypes.string,
	};

	render() {
		return (
			<Wrapper>
        {this.props.title && <Heading>{this.props.title}</Heading>}

				<Lookup isGeocoding={this.props.isGeocoding} onLookup={this.handleLookup} />

				{this.props.geocodingResult && <Visualize geocodingResult={this.props.geocodingResult} query={this.props.query} direction={this.props.direction} />}
				<ErrorMessage message={this.props.errorMessage} />
			</Wrapper>
		);
	}

	handleLookup = (query, fields, direction) => {
		this.props.dispatch(geocode(query, fields, direction));
	};
}

function select(state) {
	return {
		isGeocoding: state.isGeocoding,
		errorMessage: state.errorMessage,
		geocodingResult: state.geocodingResult,
		query: state.query,
		direction: state.direction,
	};
}

export default connect(select)(TryApp);
